import { render, staticRenderFns } from "./Bando29Fase1.vue?vue&type=template&id=69d874d4&scoped=true"
import script from "./Bando29Fase1.vue?vue&type=script&lang=js"
export * from "./Bando29Fase1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d874d4",
  null
  
)

export default component.exports